<ngx-loading-bar class="loading-bar" color="#533E80" height="4px" [includeSpinner]="false" ref="http"></ngx-loading-bar>
<router-outlet></router-outlet>
<app-snackbar></app-snackbar>
